import { render } from "./addsplashscreen.vue?vue&type=template&id=232c20f7"
import script from "./addsplashscreen.vue?vue&type=script&lang=js"
export * from "./addsplashscreen.vue?vue&type=script&lang=js"

import "./addsplashscreen.vue?vue&type=style&index=0&id=232c20f7&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__